export default "__VITE_ASSET__CE83LoOL__"